import { Typography } from '@mui/material';

import { MediaUpload, RHFTextField } from 'components';
import { useInspectionPath } from 'hooks';
import { useInspectionSelector } from 'stores';

import {
  GridWrap,
  TitleSection,
} from './Accordion6StrutturaCommentiPerReport.style';

const Accordion6StrutturaCommentiPerReport = () => {
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();
  return (
    <>
      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">
              {'DESCRIZIONE STRUTTURA'}
            </Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneStruttura"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            defaultValue=""
            disabled={inspectionDisabled || isViewingInspection}
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoDescrizioneStruttura"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>
    </>
  );
};

export { Accordion6StrutturaCommentiPerReport };
